import type { Country } from '../../domain/country';

import countries from './countries.json';

export const WORLDWIDE_COUNTRY_ID = 999;

const makeCountryService = () => {
  const getCountries = (): Country[] => countries;

  const getCountryName = (countryId: number) => {
    if (countryId === WORLDWIDE_COUNTRY_ID) {
      return 'Worldwide';
    }

    return getCountries().find((c) => c.id === countryId)?.text ?? 'Unknown country';
  };

  const isMatchingCountryName = (searchText: string, country: Country): boolean => {
    const isMainNameMatch = country.text.toLowerCase().includes(searchText);
    const isAltNameMatch = country.altNames?.some((altName) => altName.toLowerCase().includes(searchText)) ?? false;

    return isMainNameMatch || isAltNameMatch;
  };

  const compareCountryNameLengths = (a: Country, b: Country): number => a.text.length - b.text.length;

  const suggestCountry = (text: string): Country | undefined => {
    const normalizedSearch = text.toLowerCase().trim();

    if (!normalizedSearch) {
      return;
    }

    return getCountries()
      .filter((country) => isMatchingCountryName(normalizedSearch, country))
      .sort(compareCountryNameLengths)
      .at(0);
  };

  const getCountriesByIds = (ids: number[]) => {
    const countries = getCountries();
    return countries.filter((country) => ids.includes(country.id));
  };

  const isWorldwideIncluded = (ids: number[]) => ids.some((countryId) => countryId === WORLDWIDE_COUNTRY_ID);

  return { getCountryName, suggestCountry, getCountries, getCountriesByIds, isWorldwideIncluded };
};

export const CountryService = makeCountryService();
